/**
 * URL の案件アクセストークン (`/{caseToken}/...`) を RPC 呼び出し側 (interceptor) へ
 * 受け渡すための一時保持モジュール (concierge の accessTokenGetter と同方式)。
 *
 * ゲストアプリはログインを持たず「現在表示中のページの caseToken」だけが認可の根拠になるため、
 * ルーティング側 (AppLayout) が URL パラメータの変化に合わせて `setCaseToken` を呼び、
 * caseTokenInterceptor が呼び出しのたびに `getCaseToken` を評価してヘッダへ反映する。
 */
let currentCaseToken: string | undefined;

export function setCaseToken(token: string | undefined): void {
  currentCaseToken = token;
}

export function getCaseToken(): string | undefined {
  return currentCaseToken;
}
